<script lang="ts" setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import HistoryFinances from "@/components/history/HistoryFinances.vue";
import HistoryOperations from "@/components/history/HistoryOperations.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";

interface TabType {
  title: string;
  active: boolean;
}

const { t } = useI18n();

const tabs = ref<TabType[]>([
  { title: t("history.page.tabs.finances"), active: true },
  { title: t("history.page.tabs.usage"), active: false },
]);

function toggleTabs(tab: TabType, tabArray: TabType[]) {
  tabArray.forEach((item) => (item.active = false));
  const found = tabArray.find((item) => item === tab);
  if (found) found.active = true;
}

const tabClasses = (active: boolean) => {
  return [active ? "active" : ""];
};
</script>
<template>
  <div class="history-wrapper">
    <div class="history-row">
      <div class="history-header">
        <router-link to="account" class="history-header__back">
          <BaseFigureForIcon
            size="medium"
            color="white"
            icon="arrow"
            position="left"
            is-button
          />
        </router-link>
        <div class="history-header__title">
          <p class="h3">{{ t("history.page.title") }}</p>
        </div>
        <router-link
          :to="{ name: 'settings', query: { details: true } }"
          class="history-header__link"
        >
          <div class="history-header__link-icon">
            <BaseIcon name="details" />
          </div>
          <p class="caption-navbar color-text-primary">
            {{ t("history.page.details") }}
          </p>
        </router-link>
      </div>
      <div class="history-body">
        <div class="history-body__tabs">
          <div
            v-for="(tab, index) in tabs"
            :key="index"
            class="history-body__tabs-item"
            :class="tabClasses(tab.active)"
            @click="toggleTabs(tab, tabs)"
          >
            <p class="caption-navbar color-grey-light">{{ tab.title }}</p>
          </div>
        </div>
        <template v-if="tabs[0].active">
          <HistoryFinances />
        </template>
        <template v-else>
          <HistoryOperations />
        </template>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/style/components/history";
</style>
